import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../../hooks/use-http";
import convertToExcel from "../../../../../components/ExportToExcel";
import Pagination from "../../../../../components/Pagination";
import * as XLSX from "xlsx";
import { AutoComplete } from "antd";

const FarmerSummaryDetailReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };

  const [loading, setLoading] = useState(false);

  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);

  const [seasonlist, setSeasonlist] = useState(null);
  const [seasonId, setSeasonId] = useState();

  const [ranchId, setRanchId] = useState();
  const [ranchData, setRanchData] = useState([]);

  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();

  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const [expandedGroups, setExpandedGroups] = useState({
    ActualInputs: true,
    PlanInputs: true,
    OtherServices: true,
    Yield: true,
  });
  const toggleGroup = (group) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [group]: !prev[group],
    }));
  };

  const currentItems = Array.isArray(data)
    ? data.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getSeason } = useHttp();
  useEffect(() => {
    getSeason(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setSeasonlist(data);
      }
    );
  }, [getSeason]);

  const { sendRequest: getRanch } = useHttp();
  useEffect(() => {
    getRanch(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchData(data);
      }
    );
  }, [getRanch]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    setFarmerData([]);
    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  const { sendRequest: getBudgetData } = useHttp();

  const fillBudgetData = (e) => {
    var urlfilter = "";

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (seasonId > 0) {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }

    if (ranchId > 0) {
      urlfilter = urlfilter + `&ranchId=${ranchId}`;
    }
    if (farmerNumber) {
      urlfilter = urlfilter + `&farmerNo=${farmerNumber}`;
    }

    var url = `/api/farmerSummaryDetailReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getBudgetData(
      {
        url: url,
      },
      (data) => {
        console.log(data.farmerData);

        setData(data.farmerData);
      }
    );
  };

  useEffect(() => {
    fillBudgetData();
  }, []);

  const handleExportExcel = () => {
    const filename = "FarmerSummaryDetailReport.xlsx";

    const headers = [
      "Farmer ID",
      "Farmer Name",
      "Crop",
      // "Field Category",
      "Field",
      "Region Name",
      "Ranch Name",
      "Field Code",
      "Plot Name",
      "Budget Template Name",
      "Season Name",
      "Extension Officer",
      "Field Size",
      "Field Size Unit",
    ];

    const actualInputHeaders = inputTypes.length
      ? inputTypes.map((type) => `Actual Input - ${type}`)
      : ["Actual Input -"];
    const planInputHeaders = planInputTypes.length
      ? planInputTypes.map((type) => `Plan Input - ${type}`)
      : ["Plan Input -"];
    const otherHeaders = otherTypes.length
      ? otherTypes.map((type) => `Other - ${type}`)
      : ["Other -"];

    const yieldHeaders = ["Yield Good", "Yield Bad"];

    const finalHeaders = [
      ...headers,
      ...actualInputHeaders,
      ...planInputHeaders,
      ...otherHeaders,
      ...yieldHeaders,
      "Total Cost",
      "Harvest Cost",
      "Profit / Loss",
    ];

    const rows = data.map((itm) => {
      const row = {
        "Farmer ID": itm.farmerNo ?? "-",
        "Farmer Name": itm.farmerName ?? "-",
        Crop: itm.cropName ?? "-",
        // "Field Category": itm.ranchName ?? "-",
        "Field ": itm.ranchName ?? "-",
        "RegionName ": itm.regionName ?? "-",
        "Ranch Name ": itm.ranchName ?? "-",
        "Field Code ": itm.fieldCode ?? "-",
        "Plot Name ": itm.plotName ?? "-",
        "Budget Template Name": itm.farmerBudgetTemplateName ?? "-",
        "Season Name": itm.seasonName ?? "-",
        "Extension Officer": itm.executiveName ?? "-",
        "Field Size": itm.plotArea ?? "-",
        "Field Size Unit": itm.plotAreaUnit ?? "-",
      };

      const actualInputs = Array.isArray(itm.actualInputs)
        ? itm.actualInputs
        : [];
      const planInputs = Array.isArray(itm.planInputs) ? itm.planInputs : [];
      const others = Array.isArray(itm.other) ? itm.other : [];

      if (inputTypes.length > 0) {
        inputTypes.forEach((type) => {
          const item = actualInputs.find((x) => x.poductType === type);
          row[`Actual Input - ${type}`] = item?.totalproductAmount ?? "-";
        });
      } else {
        row["Actual Input -"] = "-";
      }

      if (planInputTypes.length > 0) {
        planInputTypes.forEach((type) => {
          const item = planInputs.find((x) => x.poductType === type);
          row[`Plan Input - ${type}`] = item?.totalproductAmount ?? "-";
        });
      } else {
        row["Plan Input -"] = "-";
      }

      if (otherTypes.length > 0) {
        otherTypes.forEach((type) => {
          const item = others.find((x) => x.poductType === type);
          row[`Other - ${type}`] = item?.totalproductAmount ?? "-";
        });
      } else {
        row["Other -"] = "-";
      }

      row["Yield Good"] = itm.vehicleQualitySummary?.good?.totalCombined ?? "-";
      row["Yield Bad"] = itm.vehicleQualitySummary?.bad?.totalCombined ?? "-";

      row["Total Cost"] = itm.totalcost ?? "-";
      row["Harvest Cost"] = itm.harvestCost ?? "-";
      row["Profit / Loss"] = itm.profitLoss ?? "-";

      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.sheet_add_aoa(worksheet, [finalHeaders], { origin: "A1" });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Farmer Summary Report");

    XLSX.writeFile(workbook, filename);
  };

  const inputTypes = Array.from(
    new Set(
      data.flatMap((item) => item.actualInputs?.map((x) => x.poductType) || [])
    )
  );

  const planInputTypes = Array.from(
    new Set(
      data.flatMap((item) => item.planInputs?.map((x) => x.poductType) || [])
    )
  );

  const otherTypes = Array.from(
    new Set(data.flatMap((item) => item.other?.map((x) => x.poductType) || []))
  );

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title">Farmer Summary Detail Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Season</label>
                  <select
                    id="season"
                    className="form-control"
                    value={seasonId}
                    onChange={(e) => setSeasonId(e.target.value || 0)}
                    required
                  >
                    <option value="">Select</option>
                    {seasonlist &&
                      seasonlist.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Ranch</label>
                  <select
                    id="ranch"
                    className="form-control"
                    value={ranchId}
                    onChange={(e) => setRanchId(e.target.value || 0)}
                  >
                    <option value="">Select</option>
                    {ranchData &&
                      ranchData.map((x) => (
                        <option key={x.ranchId} value={x.ranchId}>
                          {x.ranchName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Executive Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      setEmployeeId(e.target.value || 0);
                      setFarmerNumber("");
                      setData([]);
                    }}
                  >
                    <option value={0}>Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillBudgetData();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header tableheaderrowview">
                          <th colSpan={13}>Farmer Details</th>
                          <th
                            colSpan={inputTypes.length}
                            style={{ cursor: "pointer" }}
                            onClick={() => toggleGroup("ActualInputs")}
                          >
                            Actual Inputs{" "}
                            {expandedGroups.ActualInputs ? "-" : "+"}
                          </th>

                          <th
                            colSpan={planInputTypes.length}
                            style={{ cursor: "pointer" }}
                            onClick={() => toggleGroup("PlanInputs")}
                          >
                            Plan Inputs {expandedGroups.PlanInputs ? "-" : "+"}
                          </th>

                          <th
                            colSpan={otherTypes.length}
                            style={{ cursor: "pointer" }}
                            onClick={() => toggleGroup("OtherServices")}
                          >
                            Other Services{" "}
                            {expandedGroups.OtherServices ? "-" : "+"}
                          </th>

                          <th
                            colSpan={2}
                            style={{ cursor: "pointer" }}
                            onClick={() => toggleGroup("Yield")}
                          >
                            Yield of Fruits {expandedGroups.Yield ? "-" : "+"}
                          </th>

                          <th rowSpan={2}>Total Cost</th>
                          <th rowSpan={2}>Harvest Cost</th>
                          <th rowSpan={2}>Profit / Loss</th>
                        </tr>

                        <tr className="table-subheader">
                          <th>Farmer ID</th>
                          <th>Farmer Name</th>
                          <th>Crop</th>
                          <th>Field</th>
                          <th>Field Category</th>
                          <th>Ranch Name</th>
                          <th>Field Code</th>
                          <th>Plot Name</th>
                          <th>Budget Template Name</th>
                          <th>Season Name</th>
                          <th>Extension Officer</th>
                          <th>Field Size</th>
                          <th>Field Size Unit</th>
                          {expandedGroups.ActualInputs
                            ? inputTypes.map((type) => (
                                <th key={"actual-" + type}>{type}</th>
                              ))
                            : inputTypes.map((type) => (
                                <th key={"actual-" + type}></th>
                              ))}

                          {expandedGroups.PlanInputs
                            ? planInputTypes.map((type) => (
                                <th key={"plan-" + type}>{type}</th>
                              ))
                            : planInputTypes.map((type) => (
                                <th key={"plan-" + type}></th>
                              ))}

                          {expandedGroups.OtherServices
                            ? otherTypes.map((type) => (
                                <th key={"other-" + type}>{type}</th>
                              ))
                            : otherTypes.map((type) => (
                                <th key={"other-" + type}></th>
                              ))}

                          {expandedGroups.Yield ? (
                            <>
                              <th>Good</th>
                              <th>Bad</th>
                            </>
                          ) : (
                            <th colSpan={2}></th>
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {data.map((itm, i) => (
                          <tr key={i}>
                            <td>{itm.farmerNo || "-"}</td>
                            <td>{itm.farmerName || "-"}</td>
                            <td>{itm.cropName || "-"}</td>
                            <td>{itm.ranchName || "-"}</td>
                            <td>{itm.regionName || "-"}</td>
                            <td>{itm.ranchName || "-"}</td>
                            <td>{itm.fieldCode || "-"}</td>
                            <td>{itm.plotName || "-"}</td>
                            <td>{itm.farmerBudgetTemplateName || "-"}</td>
                            <td>{itm.seasonName || "-"}</td>
                            <td>{itm.executiveName || "-"}</td>
                            <td>{itm.plotArea ?? "-"}</td>
                            <td>{itm.plotAreaUnit || "-"}</td>

                            {/* Actual Inputs */}
                            {expandedGroups.ActualInputs
                              ? inputTypes.map((type, idx) => {
                                  const item = itm.actualInputs?.find(
                                    (x) => x.poductType === type
                                  );
                                  return (
                                    <td key={`actual-${i}-${idx}`}>
                                      {item?.totalproductAmount ?? "-"}
                                    </td>
                                  );
                                })
                              : inputTypes.map((type, idx) => (
                                  <td key={`actual-${i}-collapsed-${idx}`}>
                                    -
                                  </td>
                                ))}

                            {/* Plan Inputs */}
                            {expandedGroups.PlanInputs
                              ? planInputTypes.map((type, idx) => {
                                  const item = itm.planInputs?.find(
                                    (x) => x.poductType === type
                                  );
                                  return (
                                    <td key={`plan-${i}-${idx}`}>
                                      {item?.totalproductAmount ?? "-"}
                                    </td>
                                  );
                                })
                              : planInputTypes.map((type, idx) => (
                                  <td key={`plan-${i}-collapsed-${idx}`}>-</td>
                                ))}

                            {/* Other Services */}
                            {expandedGroups.OtherServices
                              ? otherTypes.map((type, idx) => {
                                  const item = itm.other?.find(
                                    (x) => x.poductType === type
                                  );
                                  return (
                                    <td key={`other-${i}-${idx}`}>
                                      {item?.totalproductAmount ?? "-"}
                                    </td>
                                  );
                                })
                              : otherTypes.map((type, idx) => (
                                  <td key={`other-${i}-collapsed-${idx}`}>-</td>
                                ))}

                            {/* Yield of Fruits */}
                            {expandedGroups.Yield ? (
                              <>
                                <td>
                                  {itm.vehicleQualitySummary?.good
                                    ?.totalCombined ?? "-"}
                                </td>
                                <td>
                                  {itm.vehicleQualitySummary?.bad
                                    ?.totalCombined ?? "-"}
                                </td>
                              </>
                            ) : (
                              <td colSpan={2}>-</td>
                            )}

                            <td>{itm.totalcost ?? "-"}</td>
                            <td>{itm.harvestCost ?? "-"}</td>
                            <td>{itm.profitLoss ?? "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerSummaryDetailReport;
